export const PROFESSIONS = [
    "Geólogo", "Engenheiro de Minas", "Técnico", "Minerador",
    "Empresário", "Consultor", "Advogado", "Outro",
];

export const REGIMES = [
    "Autorização de Pesquisa", "Concessão de Lavra", "Licenciamento",
    "Permissão de Lavra Garimpeira", "Registro de Extração", "Outros",
];

export const PHASES = [
    "Requerimento", "Pesquisa", "Relatório Final de Pesquisa", "Requerimento de Lavra",
    "Lavra", "Disponibilidade", "Licenciamento", "PLG", "Outra",
];

export const OBLIGATION_TYPES = [
    "Vencimento de Alvará", "Relatório Final de Pesquisa", "Exigência ANM", "RAL",
    "DIPEM", "Guia de Utilização", "Licenciamento", "Taxa", "Protocolo",
    "Prorrogação de Alvará", "Cumprimento de Exigência", "Licença Ambiental", "Renovação de Licença",
    "Outorga", "Renovação de Outorga", "Entrega de Documento", "Recurso Administrativo",
    "Manifestação", "Pagamento", "Vistoria", "Prazo personalizado", "Outro",
];

export const DEADLINE_PRIORITIES = [
    { value: "BAIXA", label: "Baixa", cls: "bg-slate-100 text-slate-600 border-slate-200" },
    { value: "MEDIA", label: "Média", cls: "bg-blue-50 text-blue-700 border-blue-200" },
    { value: "ALTA", label: "Alta", cls: "bg-orange-50 text-orange-700 border-orange-200" },
    { value: "CRITICA", label: "Crítica", cls: "bg-red-50 text-red-700 border-red-200" },
];

export const RECURRENCE_OPTIONS = [
    { value: "none", label: "Não recorrente" },
    { value: "mensal", label: "Mensal" },
    { value: "trimestral", label: "Trimestral" },
    { value: "semestral", label: "Semestral" },
    { value: "anual", label: "Anual" },
    { value: "personalizado", label: "Personalizado (dias)" },
];

export const DEADLINE_STATE_META = {
    ABERTO: { label: "Aberto", cls: "bg-green-100 text-green-700 border-green-200" },
    PROXIMO: { label: "Próximo", cls: "bg-yellow-100 text-yellow-700 border-yellow-200" },
    URGENTE: { label: "Urgente", cls: "bg-[#ff7b00]/15 text-[#e66e00] border-[#ff7b00]/30" },
    VENCIDO: { label: "Vencido", cls: "bg-red-100 text-red-700 border-red-200" },
    CONCLUIDO: { label: "Concluído", cls: "bg-emerald-100 text-emerald-700 border-emerald-200" },
    CANCELADO: { label: "Cancelado", cls: "bg-slate-100 text-slate-500 border-slate-200" },
    PENDENTE_CONFIRMACAO: { label: "Pendente de confirmação", cls: "bg-purple-100 text-purple-700 border-purple-200" },
    ENCERRADO_POR_MUDANCA_DE_FASE: { label: "Encerrado (mudança de fase)", cls: "bg-slate-100 text-slate-500 border-slate-200" },
};

export const CONFIDENCE_META = {
    CONFIRMED: { label: "Confirmado", desc: "Data informada explicitamente no documento." },
    CALCULATED: { label: "Calculado pelo GM²", desc: "Data calculada a partir de regra cadastrada." },
    REVIEW_REQUIRED: { label: "Revisar", desc: "Possível prazo — revise antes de confirmar." },
};

export const DOC_CATEGORIES = [
    "ART", "Alvará", "Relatório", "Mapa", "PAE", "Licença Ambiental", "Exigência", "Comprovante", "Outro",
];

export const LEGISLATION_TYPES = [
    "Código de Mineração", "Regulamento do Código de Mineração", "Resoluções ANM", "Portarias",
    "Leis", "Decretos", "Pesquisa Mineral", "Lavra", "Guia de Utilização", "RAL", "DIPEM",
    "CFEM", "PLG", "Licenciamento", "Registro de Extração", "Disponibilidade de Áreas",
    "Transferência de Direitos Minerários",
];

export const STATUS_META = {
    normal: { label: "Normal", cls: "bg-green-100 text-green-700 border-green-200" },
    atencao: { label: "Atenção", cls: "bg-yellow-100 text-yellow-700 border-yellow-200" },
    importante: { label: "Importante", cls: "bg-orange-100 text-orange-700 border-orange-200" },
    urgente: { label: "Urgente", cls: "bg-[#ff7b00]/15 text-[#e66e00] border-[#ff7b00]/30" },
    vencido: { label: "Vencido", cls: "bg-red-100 text-red-700 border-red-200" },
};

export const ANM_SCM_URL = "https://sistemas.anm.gov.br/SCM/Extra/site/admin/dadosProcesso.aspx";

export const CONTACT_WHATSAPP = "5547984264255";
export const CONTACT_WHATSAPP_DISPLAY = "(47) 98426-4255";
export const CONTACT_EMAIL = "mapgeodrone@gmail.com";
export const CONTACT_WHATSAPP_MSG = "Olá! Tenho interesse no Geomine Manager (GM² ANM) e gostaria de mais informações.";

export const DISCLAIMER = "Geomine Manager (GM² ANM) é uma plataforma privada e independente de gestão e inteligência mineral. Não possui vínculo institucional com a Agência Nacional de Mineração – ANM ou com o Governo Federal.";

export const PLAN_PRICING = {
    essencial: { name: "GM² Essencial", price: 749 },
    avancado: { name: "GM² Avançado", price: 1390 },
    consultoria: { name: "GM² Consultoria", price: 3190 },
};
export const ADDITIONAL_PROCESS_PRICE = 199;

export const SUBSCRIPTION_STATUS_META = {
    active: { label: "Ativa", cls: "bg-green-100 text-green-700 border-green-200" },
    trial: { label: "Período de teste", cls: "bg-blue-100 text-blue-700 border-blue-200" },
    past_due: { label: "Pagamento pendente", cls: "bg-amber-100 text-amber-700 border-amber-200" },
    cancelled: { label: "Cancelada", cls: "bg-red-100 text-red-700 border-red-200" },
    expired: { label: "Expirada", cls: "bg-red-100 text-red-700 border-red-200" },
    member: { label: "Membro da equipe", cls: "bg-violet-100 text-violet-700 border-violet-200" },
};

const TRIAL_ENDED = { label: "Teste encerrado", cls: "bg-red-100 text-red-700 border-red-200" };

// Dias restantes de teste (>=1) ou 0 se já findou; null se não estiver em trial.
export function trialDaysLeft(user) {
    if (user?.subscription_status !== "trial") return null;
    const te = user?.trial_ends_at;
    const d = te ? new Date(te) : null;
    if (!d || isNaN(d.getTime())) return null;
    const ms = d.getTime() - Date.now();
    if (ms <= 0) return 0;
    return Math.ceil(ms / 86400000);
}

// Decide o rótulo/cor da tag de status. No trial: AZUL se dentro do prazo, VERMELHO se já findou.
export function subscriptionStatusView(user) {
    const status = user?.subscription_status;
    if (status === "trial") {
        const te = user?.trial_ends_at;
        const d = te ? new Date(te) : null;
        if (d && !isNaN(d.getTime()) && d.getTime() <= Date.now()) return TRIAL_ENDED;
        return SUBSCRIPTION_STATUS_META.trial;
    }
    return SUBSCRIPTION_STATUS_META[status] || { label: status || "—", cls: "bg-slate-100 text-slate-600 border-slate-200" };
}

// Retorna "há X dias/meses/anos" a partir de uma data ISO.
export function timeAgoPt(dateStr) {
    if (!dateStr) return "—";
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return "—";
    const days = Math.floor((Date.now() - d.getTime()) / 86400000);
    if (days < 0) return "há instantes";
    if (days === 0) return "hoje";
    if (days === 1) return "há 1 dia";
    if (days < 30) return `há ${days} dias`;
    const months = Math.floor(days / 30);
    if (months < 12) return months === 1 ? "há 1 mês" : `há ${months} meses`;
    const years = Math.floor(days / 365);
    const rem = Math.floor((days - years * 365) / 30);
    if (years === 1) return rem > 0 ? `há 1 ano e ${rem} ${rem === 1 ? "mês" : "meses"}` : "há 1 ano";
    return rem > 0 ? `há ${years} anos e ${rem} ${rem === 1 ? "mês" : "meses"}` : `há ${years} anos`;
}
